import { render, staticRenderFns } from "./ImportHistory.vue?vue&type=template&id=55a36a6e&scoped=true"
import script from "./ImportHistory.vue?vue&type=script&lang=js"
export * from "./ImportHistory.vue?vue&type=script&lang=js"
import style0 from "./ImportHistory.vue?vue&type=style&index=0&id=55a36a6e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a36a6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55a36a6e')) {
      api.createRecord('55a36a6e', component.options)
    } else {
      api.reload('55a36a6e', component.options)
    }
    module.hot.accept("./ImportHistory.vue?vue&type=template&id=55a36a6e&scoped=true", function () {
      api.rerender('55a36a6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WkImport/ImportHistory.vue"
export default component.exports